import { parse } from 'query-string';
import type { Location } from '@atlassian/react-resource-router';
import type { PanelType } from '../../model/panels/types';
import {
	QUERY_PARAM_EPICS,
	QUERY_PARAM_IS_INSIGHTS_OPEN,
	QUERY_PARAM_VERSIONS,
} from '../../model/routing/constants';
import type { SearchQueryParams } from '../../model/routing/types';
import {
	getPanelState,
	getPanelStateOld,
	setPanelState,
	setPanelStateOld,
	unsetPanelState,
} from '../local-storage';

export const getPanelAfterToggle = (
	currentPanel: PanelType,
	panelFromLocalStorage: PanelType | null,
): PanelType | null => (currentPanel === panelFromLocalStorage ? null : currentPanel);

export const togglePanelState = (currentPanel: PanelType, boardId?: string) => {
	if (boardId) {
		const panelStateFromLocalStorage = getPanelState(boardId);
		panelStateFromLocalStorage?.includes(currentPanel)
			? unsetPanelState(currentPanel, boardId)
			: setPanelState(currentPanel, boardId);
	} else {
		const panelStateFromLocalStorage = getPanelStateOld();
		setPanelStateOld(getPanelAfterToggle(currentPanel, panelStateFromLocalStorage));
	}
};

export const isIssueParentPanelOpen = (location?: Location) => {
	const queryParams: SearchQueryParams = parse(location ? location.search : window.location.search);
	return queryParams[QUERY_PARAM_EPICS] === 'visible';
};

export const isVersionPanelOpen = (location?: Location) => {
	const queryParams: SearchQueryParams = parse(location ? location.search : window.location.search);
	return queryParams[QUERY_PARAM_VERSIONS] === 'visible';
};

export const isInsightsPanelOpen = () => {
	// This is used in the old version and new version
	const queryParams: SearchQueryParams = parse(window.location.search);
	return queryParams[QUERY_PARAM_IS_INSIGHTS_OPEN] === 'true';
};
